export class MobileMenu {
  toolbar: Toolbar = new Toolbar();
  sections: Array<Array<NavItem>> = [];
  footer?: NavItem;
}

export class Toolbar {
  label!: string;
  icons: Array<NavItem> = [];
  routes: Array<NavItem> = [];
  languageSelector?: unknown; // LanguageSelectorComponent;
}

export class NavItem {
  label!: string;
  route!: string;
  icon?: string;
  prop?: string;
  open?: boolean;
  items?: Array<NavItem>;
  link?: string;
  description?: string;
  externalLink?: string;
  show?: boolean;
  auth?: string;
}

////////////////////////////////////////
export class NavigationConfig {
  showHamburger = false;
  navAlt = false;
  toolbar: Toolbar = new Toolbar();
  menu: MobileMenu = new MobileMenu();
  links: Array<NavItem> = [];
  icons!: {
    mobile?: Array<NavItem>;
    tablet?: Array<NavItem>;
    desktop?: Array<NavItem>;
  };
  showLogoInToolbar?: boolean;
  hideUtilityLinksInNavBar?: boolean;
  hideNavWhenLoggedOut?: boolean;
  showImage?: boolean;
  imageLink?: string;
  buttons?: any;
  alt?: string;
}
////////////////////////////////////////
